import React from 'react';
import { Link } from 'gatsby';

const CareerBlock = () => (
  <div className="pad100">
    <div className="container">
      <div className="career-block-main text-center">
        <h2 className="heading">Join us to Make your Mark</h2>
        <p>
          At Powerplay, we’re all about delivering better experiences for our
          customers. Join our team filled with the country’s sharpest minds to
          deliver innovative solutions.
        </p>
        <Link className="button" to="/career/">
          Explore Opportunities
        </Link>
        <div className="career-graphic">
          <img className="hidden-mobile" src="/img/career-graphic.png" alt="" />
          <img
            className="visible-mobile"
            src="/img/career-graphic-mobile.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
);
export default CareerBlock;
